import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-success alert-dismissible",
  role: "alert"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Successfully ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "aria-label": "Close"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card py-3" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "row invoice-preview"
}
const _hoisted_13 = { class: "col-xl-9 col-md-8 col-12 mb-md-0 mb-4" }
const _hoisted_14 = { class: "card invoice-preview-card" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "d-flex justify-content-between flex-xl-row flex-md-column flex-sm-row flex-column p-sm-3 p-0" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-xl-0 mb-4\"><div class=\"d-flex svg-illustration mb-4 gap-2\"><span class=\"app-brand-text demo menu-text fw-bolder ms-2 text-uppercase\">Company</span></div><p class=\"mb-1\">House: E/15, Block: E, Zakir Hossain Road</p><p class=\"mb-1\">Lalmatia, Dhaka - 1207</p><p class=\"mb-0\">+880 1881 242071, +880 1710 001337</p></div>", 1)
const _hoisted_18 = { class: "mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Date Issues:", -1)
const _hoisted_20 = { class: "fw-medium" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", { class: "my-0" }, null, -1)
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "row p-sm-3 p-0" }
const _hoisted_24 = { class: "col-xl-12 col-md-12 col-sm-7 col-12" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h6", { class: "pb-2" }, "Bill To:", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Cutomer Name", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Customer Type", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Customer Phone", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Address:", -1)
const _hoisted_30 = { class: "table-responsive mx-4" }
const _hoisted_31 = { class: "table table-bordered m-0 text-center" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Price"),
    /*#__PURE__*/_createElementVNode("th", null, "Quantity"),
    /*#__PURE__*/_createElementVNode("th", null, "Total")
  ])
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "text-end"
}, "Sub Total =", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "text-end"
}, "Discount = ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "text-end"
}, "Total =", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createTextVNode("Software Design & Development by ❤️ "),
        /*#__PURE__*/_createElementVNode("strong", null, "PhicsArt"),
        /*#__PURE__*/_createTextVNode("!")
      ])
    ])
  ])
], -1)
const _hoisted_37 = { class: "col-xl-3 col-md-4 col-12 invoice-actions" }
const _hoisted_38 = { class: "card" }
const _hoisted_39 = { class: "card-body" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary d-grid w-100 mb-3",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#sendInvoiceOffcanvas"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center justify-content-center text-nowrap" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-paper-plane bx-xs me-1" }),
    /*#__PURE__*/_createTextVNode("Send Invoice To Cutomer")
  ])
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-label-secondary btn-default border d-grid w-100 mb-3" }, " Download ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.successReport)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", null, "Invoice No: " + _toDisplayString(_ctx.orderData.invoice_no), 1),
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.orderData.created_at), 1)
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("table", null, [
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_26,
                                _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer_name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_27,
                                _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer_type), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_28,
                                _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer_phone), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_29,
                                _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer_address), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("table", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.order_items, (dataItem) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: dataItem.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(dataItem.id), 1),
                              _createElementVNode("td", null, _toDisplayString(dataItem.product_id), 1),
                              _createElementVNode("td", null, _toDisplayString(dataItem.sell_price), 1),
                              _createElementVNode("td", null, _toDisplayString(dataItem.quantity), 1),
                              _createElementVNode("td", null, _toDisplayString(dataItem.total), 1)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("tfoot", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_33,
                            _createElementVNode("th", null, _toDisplayString(_ctx.orderData.sub_total), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_34,
                            _createElementVNode("th", null, _toDisplayString(_ctx.orderData.discount), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_35,
                            _createElementVNode("th", null, _toDisplayString(_ctx.orderData.total), 1)
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_36
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _hoisted_41,
                      _createElementVNode("button", {
                        class: "btn btn-label-secondary border d-grid w-100 mb-3",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printInvoice && _ctx.printInvoice(...args)))
                      }, " Print ")
                    ])
                  ])
                ])
              ]))
        ])
      ])
    ])
  ], 64))
}